import { EnvelopeSimple } from "phosphor-react";
import { InputWithLabelErrorPrefix } from "./Shared";

export function EmailInput({ value, setValue, isLoading, error, id }) {
  return (
    <InputWithLabelErrorPrefix
      type="email"
      value={value}
      label="Email Address"
      id={id}
      placeholder="username@example.com"
      prefix={<EnvelopeSimple size={16} />}
      disabled={isLoading}
      required={true}
      error={error}
      onChange={(e) => setValue(e.target.value)}
      width="100%"
      labelTop
    />
  );
}
